import React, { useEffect, useState } from 'react';
import { BinaryLike, createHash } from 'crypto';
import useChains from './useChains';
import { mockSolEvmChainId } from '../config/sol';
import { useWebApp } from '@vkruglikov/react-telegram-web-app';
import { GetBalanceReturnType } from '@wagmi/core';
import useOTC from './useOTC';
import { Web3Type } from '../config/type';
import useTomoUserInfo from './useTomoUserInfo';
import { useQuery } from '@tanstack/react-query';
import { getOnRampTokens } from '../api';
import { OnRampToken } from '../api/type';

export interface TokenInfo extends OnRampToken {}

export const useOnRampTokens = () => {
  const { evmAddress, solAddress } = useTomoUserInfo();

  const onRampTokensQuery = useQuery({
    queryKey: ['onRampTokens', evmAddress, solAddress],
    queryFn: () =>
      getOnRampTokens({ evm_address: evmAddress, solana_address: solAddress }),
  });

  const tokens = onRampTokensQuery?.data ?? [];

  return {
    tokens,
  };
};

export default function useOnRamp({
  type,
  rampType,
  token,
}: {
  type: 'buy' | 'sell';
  rampType: 'ramp' | 'mercuryo';
  token: TokenInfo | undefined;
}) {
  const webApp = useWebApp();
  const { showRamp } = useOTC();
  const chain_id = token?.chain_id;
  const { chains } = useChains();
  const chain = chains.find(c => {
    if (!chain_id) {
      if (token?.symbol == Web3Type.BTC) {
        return c?.type == Web3Type.BTC;
      }
    }
    if (chain_id == mockSolEvmChainId) {
      return c?.type == Web3Type.SOL;
    }
    return c.chain?.id == chain_id;
  });

  const { userInfo } = useTomoUserInfo();

  const user = userInfo;
  const onContinue = () => {
    if (!token) return;
    if (type == 'buy') {
      if (rampType == 'ramp') {
        showRamp(token);
      } else {
        const address =
          chain?.type == 'SOL'
            ? user?.solanaAddress
            : chain?.type == Web3Type.BTC
            ? user?.bitcoinP2trAddress
            : user?.v2Address;

        //token?.contract || token?.address || ZeroAddress

        const data = `${address}}`;
        const bytes = (Buffer.from(data, 'utf8') as unknown) as BinaryLike;

        const signature = createHash('sha512')
          .update(bytes)
          .digest('hex');

        const chainName = token?.ramp_support
          ? token?.ramp_support.split('_')[0]
          : chain?.name?.toLocaleUpperCase();

        const tokenName = token?.ramp_support
          ? // ? token.ramp_support
            token?.ramp_support.split('_')[1]
          : token?.symbol.toLocaleUpperCase();

        // &Currencies=${tokenName}
        // &networks=${chainName}
        const link = `https://exchange.mercuryo.io/?widget_id=ebadd34c-c7ff-4c43-8097-b5f66b8b5f11&currency=${tokenName}&network=${chainName}&address=${address}&signature=${signature}&type=buy&fix_currency=true`;
        if (window.location.protocol == 'http:') {
          window.location.href = link;
        } else {
          return webApp.openLink(link);
        }
      }
    } else {
      const chainName = token?.mercuryo_support
        ? token?.mercuryo_support.split('_')[0]
        : chain?.name?.toLocaleUpperCase();

      const tokenName = token.mercuryo_support
        ? token?.mercuryo_support.split('_')[1]
        : token?.symbol.toLocaleUpperCase();

      const link =
        'https://exchange.mercuryo.io/' +
        `?currency=${tokenName}&networks=${chainName}&type=sell`;

      if (window.location.protocol == 'http:') {
        window.location.href = link;
      } else {
        return webApp.openLink(link);
      }
    }
  };

  //  token?.ramp_support?.length

  const renderTitle = (type === 'buy'
  ? token?.ramp_support && token?.ramp_support.length > 0
  : token?.mercuryo_support && token?.mercuryo_support.length > 0)
    ? token?.symbol.toLocaleUpperCase()
    : 'Asset';

  return {
    onContinue,
    title: renderTitle,
  };
}
